import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import { getUser } from '../Components/Pages/Admin/User/userApi';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

// 1️⃣ Define the user data type
export interface UserDataType {
  DynamicColumn: string;
  EmailID: string;
  ImageData: string;
  IsLoggedIn: boolean;
  LastRequest: string;
  MIMEType: string;
  UpdatedBy: string;
  UpdatedDate: string;
  UserID: string;
  UserName: string;
  UserNum: number;
  UserRole: string;
  UserStatus: string;
}

// 2️⃣ Define the context structure
interface GlobalContextType {
  userData: UserDataType;
  setUserData: (user: UserDataType) => void;
  dataLoading:Boolean
}

// 3️⃣ Create the context
const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

// 4️⃣ Create a provider component
export const GlobalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userData, setUserData] = useState<UserDataType>({
    DynamicColumn: '',
    EmailID: '',
    ImageData: '',
    IsLoggedIn: false,
    LastRequest: '',
    MIMEType: '',
    UpdatedBy: '',
    UpdatedDate: '',
    UserID: '',
    UserName: '',
    UserNum: 0,
    UserRole: '',
    UserStatus: '',
  });
  const [dataLoading, setDataLoading] = useState(true);
  const { tenant } = useParams<{ tenant: string }>();
  const candidate_access_token = sessionStorage.getItem('candidate_session');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getUser(tenant)
        if(result){
          setUserData(result);
          setDataLoading(false)
        }
      } catch (error) {
        console.log(error)
      }
    };
    if (!candidate_access_token) {
      fetchData();
    }
  }, [tenant]);

  if(dataLoading && !candidate_access_token){
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <GlobalContext.Provider value={{ userData, setUserData,dataLoading }}>
      {children}
    </GlobalContext.Provider>
  );
};

// 5️⃣ Custom hook to consume the context
export const useGlobalContext = (): GlobalContextType => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  return context;
};
